export default{

    titulo:{
        salones: 'Aulas',
        salon: 'Aula',
        salonArticulo: 'El Aula',
        salonesArticulo: 'Las Aulas',

        cursos: 'Asignaturas',
        curso: 'Asignatura',
        cursoArticulo: 'La Asignatura',
        cursosArticulo: 'Las Asignaturas',

        sesionAprendizaje: 'Plan de Clase',
        sesionesAprendizajes: 'Planes de Clases',
        sesionAprendizajeArticulo: 'El Plan de Clase',
        sesionesAprendizajesArticulo: 'Los Planes de Clases',

        director: 'Rector',
        directores: 'Rectores',
        directorArticulo: 'El Rector',
        directoresArticulo: 'Los Rectores',

        colegio: 'Unidad Educativa',
        colegios: 'Unidades Educativas',
        colegioArticulo: 'La Unidad Educativa',
        colegiosArticulo: 'Las Unidades Educativas',

        progDocente: 'Planificación de Clase',
        progDocentes: 'Planificaciones de Clases',
        progDocenteArticulo: 'La Planificación de Clase',
        progDocentesArticulo: ' Las Planificaciones de Clases',

        codigoNivelGrado: 'Codigo Modular Ecuatoriano',
        codigoArea: 'Codificación Ecuador'

    },


    ubicacion:{
        pais: 'País',
        ubicacion1: 'Estado',
        ubicacion2: 'Ciudad',
        ubicacion3: 'Municipio'
    },


   
    modulos:{
        10: "Inicio",
        11: "Manager",
        20: "Reportes",
        1000:"Configuración Sistema",
        1100:"Inventario",
        1200:"Cliente",
        1300:"Gastos",
        1400:"Compra",
        1500:"Venta",
        1600:"Administrativo",
        1900:"Agremiado",
        2000:"Website"
    },

    subModulos:{
        100: "Gestión de Empresas",
        110: "Gestión de Licencias",
        120: "Permisos de Usuarios",
        130: "Usuarios",
        
        1000:"Configuración",
        1010:"Perfil Usuario",
        1020:"Usuario Sistema",
        1030:"Impuesto",
        1035:"Transporte",
        1040:"Tipo de Documento",
        1045:"Moneda",
        1050:"Zona",

        1101:"Productos",
        1102:"Ajuste",
        1103:"Existencia",
        1104:"Almacén",
        1105:"Categoría",
        1106:"Línea",
        1107:"Sublínea",
        1108:"Unidad Medida",
        1109:"Proveedor",
        1110:"Alerta de stock",

        1201:"Cliente",
        1202:"Tipo de Cliente",
        1203:"Agremiado",
        1205:"Vendedor",
        1206:"Tipo de Vendedor",   
        
        1410:"Compra",
        1420:"Proveedor",
        1430:"Tipo de proveedor",

        
        1310:"Gastos",
        1320:"Beneficiario",
        1330:"Categoria gasto",
        1510:"Venta",
        1550:"Cuenta por cobrar",
        1560:"Cuenta por cobrar masivo",
        1590:"Reportes de Ventas",

        1610:"Importar",
        
        1910:"Constancia de afiliacion",
        1920:"Carnet electrónico",

        
        2110:"Documentos",
        2120:"Documentos Categoría",

        2210:"Noticias",
        2220:"Noticias Categoría"

    },


    action:{
        delete: 'Borrar'
    }


}